// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__TwYqw","selects":"Documents_selects__2loAJ"};